import { fetchCompanyApi, fetchCountriesApi } from './api'
import { fetchItems } from './items'
import { fetchShipback } from './shipback'
import { fetchCustomer } from './customer'

export const SET_COMPANY = 'SET_COMPANY';
export const REQUEST_COMPANY = 'REQUEST_COMPANY';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const REQUEST_COUNTRIES = 'REQUEST_COUNTRIES';

function setCompany(company) {
  return {
    type: SET_COMPANY,
    company: company
  };
}

function requestCompany() {
   return {
    type: REQUEST_COMPANY,
  };
}

function setCountries(countries) {
  return {
    type: SET_COUNTRIES,
    countries: countries
  };
}

function requestCountries() {
   return {
    type: REQUEST_COUNTRIES,
  };
}

export function fetchCompany(company_id, user_token) {
  return function (dispatch) {
    dispatch(requestCompany())
    return fetchCompanyApi(company_id, user_token)
    .then(json => {
        dispatch(setCompany(json))
        dispatch(fetchCountries(company_id, user_token))
        dispatch(fetchShipback(shipback_id, user_token))
        dispatch(fetchCustomer(shipback_id, user_token))
        dispatch(fetchItems(shipback_id, user_token, true))

      }
    )
  }
}

export function fetchCountries(company_id, user_token) {
  return function (dispatch) {
    dispatch(requestCompany())
    return fetchCountriesApi(company_id, user_token)
    .then(json =>
      dispatch(setCountries(json))
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/actions/company.js